import { render, staticRenderFns } from "./TepTurnoPivotTable.vue?vue&type=template&id=2fef48dc"
import script from "./TepTurnoPivotTable.vue?vue&type=script&lang=js"
export * from "./TepTurnoPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports